import { z } from "zod";

const productSchema: z.ZodType<Record<string, unknown>> = z.record(z.unknown());

export const pricelistCatalogEntrySchema = z.object({
  display_name: z.string(),
  tag: z.string()
});

export const pricelistCatalogCategorySchema = z.object({
  category: z.string(),
  pricelists: z.array(pricelistCatalogEntrySchema)
});

export const pricelistCatalogResponseSchema = z.object({
  brands: z.array(
    z.object({
      brand: z.string(),
      categories: z.array(pricelistCatalogCategorySchema)
    })
  )
});

export const pricelistGridCellSchema = z.object({
  section: z.string().optional(),
  row: z.string(),
  column: z.string(),
  price: z.number(),
  label: z.string(),
  product: productSchema,
  supports_frls: z.boolean(),
  supports_pvc: z.boolean()
});

export const pricelistGridSchema = z.object({
  brand: z.string(),
  display_name: z.string(),
  tag: z.string(),
  category: z.string(),
  rows: z.array(z.string()),
  columns: z.array(z.string()),
  cells: z.array(pricelistGridCellSchema)
});

export const pricelistGridResponseSchema = z.object({
  grids: z.array(pricelistGridSchema)
});

export const pdfGenerationResponseSchema = z.object({
  ok: z.boolean(),
  quotation_number: z.string(),
  filename: z.string(),
  path: z.string(),
  url: z.string()
});

export const latestPriceResponseSchema = z.object({
  found: z.boolean(),
  list_price: z.number().nullable(),
  rate: z.number().nullable()
});

export const authSessionResponseSchema = z.object({
  authenticated: z.boolean()
});

export const webWorkspaceSummarySchema = z.object({
  id: z.string(),
  title: z.string(),
  last_pdf_number: z.string().nullable(),
  updated_at: z.string()
});

export const webWorkspaceRecordSchema = webWorkspaceSummarySchema.extend({
  state: z.unknown(),
  last_pdf_url: z.string().nullable(),
  created_at: z.string()
});

export const webWorkspaceListResponseSchema = z.object({
  workspaces: z.array(webWorkspaceSummarySchema)
});

export const webWorkspaceResponseSchema = z.object({
  workspace: webWorkspaceRecordSchema
});

export type CatalogResponseDto = z.infer<typeof pricelistCatalogResponseSchema>;
export type CatalogBrandDto = CatalogResponseDto["brands"][number];
export type CatalogCategoryDto = CatalogBrandDto["categories"][number];
export type CatalogPricelistDto = CatalogCategoryDto["pricelists"][number];
export type PricelistGridDto = z.infer<typeof pricelistGridSchema>;
export type PricelistGridCellDto = z.infer<typeof pricelistGridCellSchema>;
export type PdfGenerationResponseDto = z.infer<typeof pdfGenerationResponseSchema>;
export type LatestPriceResponseDto = z.infer<typeof latestPriceResponseSchema>;
export type AuthSessionResponseDto = z.infer<typeof authSessionResponseSchema>;
export type WebWorkspaceSummaryDto = z.infer<typeof webWorkspaceSummarySchema>;
export type WebWorkspaceRecordDto = z.infer<typeof webWorkspaceRecordSchema>;
